import { reducerWithInitialState } from "typescript-fsa-reducers";
import { combineReducers } from "redux";

import withImmer from "../../lib/withImmer";
import { loadCompanyValueFeatures, bootstrapValuesIndex } from "../actions";
import searchReducer, { CompanyValueSearchState } from "./search";
import { CompanyValueFeature } from "../api/index";

export type CompanyValueFeature = CompanyValueFeature;

export interface CompanyValuesMainState {
  list: CompanyValueFeature[];
  isLoading: boolean;
  isLoaded: boolean;
  errorMessage?: string;
}

export interface CompanyValuesState {
  features: CompanyValuesMainState;
  search: CompanyValueSearchState;
}

const featuresReducer = withImmer(
  reducerWithInitialState<CompanyValuesMainState>({
    list: [],
    isLoading: false,
    isLoaded: false,
  })
)
  .case(bootstrapValuesIndex, (state, result) => {
    Object.assign(state, {
      isLoading: false,
      isLoaded: true,
      list: result.company_value_features,
    });
    return state;
  })
  .case(loadCompanyValueFeatures.started, state => {
    state.isLoading = true;
    return state;
  })
  .case(loadCompanyValueFeatures.done, (state, { result }) => {
    Object.assign(state, { isLoading: false, isLoaded: true, list: result });
    return state;
  })
  .case(loadCompanyValueFeatures.failed, (state, err) => {
    Object.assign(state, { isLoading: false, isLoaded: false, errorMessage: err.error.message });
    return state;
  });

export default combineReducers({
  features: featuresReducer,
  search: searchReducer,
});



// WEBPACK FOOTER //
// ./frontend/src/company_values/reducers/index.ts